import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionMark = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M20 33C20.5523 33 21 32.5702 21 32.04C21 31.5098 20.5523 31.08 20 31.08C19.4477 31.08 19 31.5098 19 32.04C19 32.5702 19.4477 33 20 33Z",
		fill: "currentColor",
		stroke: "currentColor",
		strokeWidth: 2
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15 10.1076C19.0812 8.37623 24.362 8.58202 26.1655 11.3839C27.9691 14.1859 26.7241 17.4449 23.6323 19.9599C20.5405 22.4749 19.4254 23.8402 19.4254 25.819",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10,
		strokeLinecap: "square",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgQuestionMark);
export default ForwardRef;
